export default "__VITE_ASSET__BAFlnb9A__"